import Project from "@/types/Project";
import { antimanti } from "./antimanti";
import { atlasMall } from "./atlas_mall";
import { callBlaze } from "./call_blaze";
import { solarMonitoring } from "./solar_monitoring";
import { sofreh } from "./sofreh";
import { sourena } from "./sourena";
import { tomorrowsCuisine } from "./tomorrows_cuisine";

export const PROJECTS: Project[] = [
    antimanti,
    atlasMall,
    sofreh,
    sourena,
    tomorrowsCuisine,
    callBlaze,
    solarMonitoring,
];

